<script setup lang="ts">
import {computed, ref, watch} from "vue";
// Алиас для обратной совместимости
import VLessonLayoutBlock1CardView from "./blocks/VLessonLayoutBlock1CardView.vue";
import VLessonLayoutBlock2CardView from "./blocks/VLessonLayoutBlock2CardView.vue";
import VLessonLayoutBlock3CardView from "./blocks/VLessonLayoutBlock3CardView.vue";
import VLessonLayoutBlock4CardView from "./blocks/VLessonLayoutBlock4CardView.vue";
import VLessonLayoutBlock5CardView from "./blocks/VLessonLayoutBlock5CardView.vue";
import VLessonLayoutBlock6CardView from "./blocks/VLessonLayoutBlock6CardView.vue";
import VLessonLayoutBlock7CardView from "./blocks/VLessonLayoutBlock7CardView.vue";
import VLessonLayoutBlock8ListView from "./blocks/VLessonLayoutBlock8ListView.vue";
import VLessonLayoutBlock9CardView from "./blocks/VLessonLayoutBlock9CardView.vue";
import VLessonLayoutBlock10CardView from "./blocks/VLessonLayoutBlock10CardView.vue";
import VLessonPlaceholder from "./VLessonPlaceholder.vue";
import {LayoutBlockType} from "./types/fields.enum";

// Прокидываем все пропси в LessonLayoutViewer
const props = defineProps<{
  modelValue: any;
  mode?: "view" | "edit";
  showAnswers?: boolean;
}>();

const emit = defineEmits<{ 'update:modelValue': [value: any] }>();

const currentLayoutType = computed(() => {
  return props.modelValue?.data?.blockType ?? null;
});

const layout = computed(() => {
  return props.modelValue || null;
});

const isEmptyLayout = computed(() => {
  return !layout.value || !layout.value.data;
});

</script>

<template>
  <div class="lesson-layout-component-container" >
    <Transition name="layout-fade"
                mode="out-in">
      
      <VLessonLayoutBlock1CardView v-if="layout && currentLayoutType === LayoutBlockType.BLOCK1"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock2CardView v-else-if="currentLayoutType === LayoutBlockType.BLOCK2"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock3CardView v-else-if="currentLayoutType === LayoutBlockType.BLOCK3"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock4CardView v-else-if="currentLayoutType === LayoutBlockType.BLOCK4"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock5CardView v-else-if="currentLayoutType === LayoutBlockType.BLOCK5"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock6CardView v-else-if="currentLayoutType === LayoutBlockType.BLOCK6"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   :showAnswers="props.showAnswers"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock7CardView v-else-if="currentLayoutType === LayoutBlockType.BLOCK7"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock8ListView v-else-if="currentLayoutType === LayoutBlockType.BLOCK8"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock9CardView v-else-if="currentLayoutType === LayoutBlockType.BLOCK9"
                                   :modelValue="layout"
                                   :mode="props.mode"
                                   @update:modelValue="$emit('update:modelValue', $event)" />
      <VLessonLayoutBlock10CardView v-else-if="currentLayoutType === LayoutBlockType.BLOCK10"
                                    :modelValue="layout"
                                    :mode="props.mode"
                                    @update:modelValue="$emit('update:modelValue', $event)" />

      <VLessonPlaceholder v-else />
    </Transition>
  </div>
</template>

<style scoped>
.layout-fade-enter-active,
.layout-fade-leave-active {
  transition: all 0.3s ease;
}

.layout-fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.layout-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
